export default function setWindowTitle(title) {
    if(title !== undefined && title != "") {
        title = title.trim() + " | ";
    }

    document.title = title + "Robostack";
}
